"use client"

import { sellLinks } from '@components/search/formLinks'
import { MenuPanel } from './MenuControl'
import MenuAccountGroup from './MenuAccountGroup'
import { MenuGroup, MenuLinks } from './MenuParts'

import {
    COLISION_DOC_PAGE,
    DAT_PAGE,
    FIRM_BASE_PAGE,
    INTEGRATION_PAGE,
    NEW_DEALER_ACCOUNT_PAGE,
    NEWS_PAGE,
    PRICING_PAGE,
    SALE_BUY_DOC_PAGE,
    SALE_DOC_PAGE,
} from '@constants/routes'

import styles from './SiteHeader.module.css'

const HOST = process.env.NEXT_PUBLIC_HOST

// Kolejność kategorii w menu; linki z sellLinks (wyszukiwarka ma własną kolejność).
const CATEGORY_ORDER = ['Osobowe', 'Dostawcze', 'Części', 'Ciężarowe', 'Motocykle', 'Przyczepy', 'Wynajem', 'Serwis', 'Narzędzia', 'Rolnicze', 'Budowlane', 'Kupię']
const categoryLinks = CATEGORY_ORDER
    .map(t => sellLinks.find(link => link.t === t))
    .filter(Boolean)
    .map(link => ({ t: link.t, to: HOST + link.to }))

const groups = [
    { id: 'mg-uslugi', label: 'Usługi', links: [
        { t: 'Wycena szkody', to: HOST + DAT_PAGE },
        { t: 'Dekoder VIN', to: HOST + DAT_PAGE },
    ] },
    { id: 'mg-samochody', label: 'Samochody.pl', links: [
        { t: 'Baza firm', to: HOST + FIRM_BASE_PAGE },
        { t: 'Blog', to: HOST + NEWS_PAGE },
    ] },
    { id: 'mg-firmy', label: 'Dla firm', links: [
        { t: 'Integracje', to: HOST + INTEGRATION_PAGE },
        { t: 'Cennik', to: HOST + PRICING_PAGE },
        { t: 'Dodaj firmę', to: HOST + NEW_DEALER_ACCOUNT_PAGE },
    ] },
    { id: 'mg-dokumenty', label: 'Dokumenty', links: [
        { t: 'Umowa sprzedaży', to: HOST + SALE_DOC_PAGE },
        { t: 'Oświadczenie sprawcy kolizji', to: HOST + COLISION_DOC_PAGE },
        { t: 'Zgłoszenie sprzedaży samochodu', to: HOST + SALE_BUY_DOC_PAGE },
    ] },
]

// Moduł kliencki: linki są w HTML z serwera, a w danych RSC tylko odwołanie do komponentu.
// Panel od 1024 px, szuflada poniżej (MenuPanel).
export default function SiteMenu () {
    return (
        <MenuPanel>
            <div className={styles.menuGrid}>
                <MenuGroup className={styles.menuGroupCat} id="mg-kategorie" label="Kategorie">
                    <MenuLinks links={categoryLinks} />
                </MenuGroup>
                <div className={styles.menuRest}>
                    { groups.map(group => (
                        <MenuGroup id={group.id} key={group.id} label={group.label}>
                            <MenuLinks links={group.links} />
                        </MenuGroup>
                    )) }
                    <MenuAccountGroup />
                </div>
            </div>
        </MenuPanel>
    )
}
